<template>
  <div class="button-options-data-dialog">
    <el-collapse v-model="activeNames" style="width: 100%">
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
        title="跳转地址"
        name="1"
      >
      <div class="setting-item">
        <div class="fs14 mb16">{{ sourceData[0].label }}</div>
        <div class="content-item">
          <el-select style="width: 100%" v-model="selectValue" placeholder="请选择" @change="selectPage">
            <el-option v-for="item in internalLinks" :key="item.value" :label="item.name" :value="item"></el-option>
          </el-select>
        </div>
      </div> 
      </el-collapse-item>
    </el-collapse>
    <!-- <div class="setting-item mb40">
      <div class="title mb16">按钮内容</div>
      <div class="content">
        <div class="content-item verticallyCenter mb16">
          <label class="font14 mr10">文案</label>
          <el-input class="text-inp" v-model="content"></el-input>
        </div>
      </div>
    </div>
    <div class="setting-item">
      <div class="font14 mb16">链接地址</div>
      <linkSet
        :linkAddress.sync="linkAddress"
        :internalLinkName.sync="internalLinkName"
        :linkUrl.sync="linkUrl"
        :accessRulers.sync="accessRulers"
        :openBlankPage.sync="openBlankPage"
      />
    </div> -->
  </div>
</template>

<script>
export default {
  name: "button-options-data",
  components: {},
  props: { options: Object },
  data() {
    return {
      linkAddress: "无",
      collapseActiveNames: ["1", "2", "3"],
      activeNames: ["1", "2", "3"],
      selectValue: ""
    }
  },
  comments: {},
  mounted() {    
    this.selectValue = this.internalLinks.find(item => this.homeLinkVal.includes(item.value))
  },
  computed: {
    content: {
      get() {
        return this.options.content
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "content", false)
      }
    },
    openBlankPage: {
      get() {
        return this.options.openBlankPage
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openBlankPage", false)
      }
    },
    accessRulers: {
      get() {
        return this.options.accessRulers ? this.options.accessRulers : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "accessRulers", false)
      }
    },
    internalLinkName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "internalLinkName", "internalLinkName", "")
      },
      set(val) {
        this.$changeOptionsEV(val, "internalLinkName", false)
      }
    },
    linkUrl: {
      get() {
        if (this.options.linkUrl !== "") {
          this.linkAddress = this.internalLinkName ? "内部链接" : "自定义"
        } else {
          this.linkAddress = "无"
        }
        return this.options.linkUrl
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "linkUrl", false)
      }
    },
    sourceData() {
      return this.options.sourceData
    },
    internalLinks() {
      let pageList = this.$store.state.states.pageList
      let linkArr = []
      pageList.forEach(page => {
        if (!page.template.includes("_sub")) {
          linkArr.push({
            name: page.name,
            value: page.publicId,
            url: page.url
          })
        }
        
      })
      return linkArr
    },
    homeLinkVal: {
      get() {
        let homeLinkVal = this.options.hasOwnProperty("homeLinkVal") ? this.options.homeLinkVal : ""
        return homeLinkVal
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "homeLinkVal", false)
      }
    },
  },
  methods: {
    selectPage(item) {
      let url = `/v2/p/${item.value}`
      this.selectValue = item.name
      this.homeLinkVal = url
    }
  }
}
</script>

<style scoped>
.no-break {
  word-break: keep-all;
}
.text-inp {
  max-width: 236px;
  width: calc(100% - 50px);
}
</style>
